import React from "react";

import { Spacer } from "shared/layout";
import { formatDateTime } from "shared/utils";
import { IPeopleBlockUser } from "Bands/types";
import { BoldText, SmallText } from "shared/styles";

export const PeopleBlockUserDetail: React.FC<IPeopleBlockUser> = ({ updates }) => {
  return (
    <Spacer size="xs" data-testid="people_block_user_detail">
      <BoldText>Updates</BoldText>
      <ul>
        {!updates?.length && (
          <li>
            <SmallText>No updates</SmallText>
          </li>
        )}
        {updates?.map(({ id, action, user, date }) => (
          <li key={id}>
            <SmallText>
              {action} on {formatDateTime(date)} by {user.firstname} {user.lastname}
            </SmallText>
          </li>
        ))}
      </ul>
    </Spacer>
  );
};
